import React from 'react';

import './godisnjiplan.css'


const GodisnjiPlan = () => (
    <div>
 <div className="table-godisnji-plan">
   <div className="header-table-godisnji-plan">Plan Akcija za 2020 
      <a className="pdf-icon" href="/img/plan.pdf" download>
         <img src="/img/downloadpdf.png" alt="plan pdf" className="aboutUs-pdf-icon" />
      </a>
   </div>
   
   <table >
      <thead>
      <tr>                
         <th width="20%">Datum</th>
         <th width="55%">Akcija</th>
         <th width="25%">Organizator</th>
      </tr>
      </thead>

   <tbody>
      <tr>         
         <td>Januar 02</td>         
         <td>Kablar (889m.)</td>
         <td>S. FIlipović</td>
      </tr>

      <tr>        
         <td>Januar 11</td>        
         <td>Božićnji uspon na Rtanj (1565m.)</td>
         <td>R. Vićentijević</td>
      </tr>

      <tr>       
         <td>Januar 26</td>         
         <td>Rudnik (1132m.)</td>
         <td>M. Jeremić </td>
      </tr>
      
      <tr>        
         <td>Februar 02</td>        
         <td>Vujan (856 m.)</td>
         <td>M. Jeremić</td>
      </tr>
      <tr>        
         <td>Februar 08</td>        
         <td>Rajac (848 m.)</td>
         <td>D. Jaćimović</td>
      </tr>
      <tr>        
         <td>Februar 15-16</td>        
         <td>San Marino</td>
         <td>M. Čolovic</td>
      </tr>
      <tr>         
         <td>Februar 23</td>         
         <td>Ostrvica (758m.)</td>
         <td>B. Marković</td>
      </tr>

      <tr>        
         <td>Februar 28-01</td>        
         <td>Kopaonik (2017m.)</td>
         <td>A. Bujagić</td>
      </tr>
      <tr>       
         <td>Mart 15</td>         
         <td>Bliznačko Brdo</td>
         <td>M. Jeremić </td>
      </tr>      
      <tr>        
         <td>Mart 22</td>        
         <td>Studena Planina</td>
         <td>R. Žmurić</td>
      </tr>
      <tr>         
         <td>Mart 29</td>         
         <td>Topužnica (1160m.)</td>
         <td>S. Filipović</td>
      </tr>

      <tr>        
         <td>April 05</td>        
         <td>Povlen (1347m.)</td>
         <td>R. Žmurić</td>
      </tr>

      <tr>       
         <td>April 11-12</td>         
         <td>Stara Planina (2376m.)</td>
         <td>R. Milanović </td>
      </tr>
      
      <tr>        
         <td>April 26</td>        
         <td>Taorska vrela (1000 m.)</td>
         <td>D. Jaćimović</td>
      </tr>
      <tr>         
         <td>Maj 02-03</td>         
         <td>Besna Kobila (1913m.)</td>
         <td>J. Janošević</td>
      </tr>
      <tr>        
         <td>Maj 10</td>        
         <td>Sređivanje staze za Grebenčiće </td>
         <td> </td>
      </tr>
      <tr>       
         <td>Maj 16-17</td>         
         <td>Višegrad</td>
         <td>B. Marković </td>
      </tr>      
      <tr>        
         <td>Maj 24</td>        
         <td>Grebenčići</td>
         <td></td>
      </tr>
      <tr>       
         <td>Maj 30-31</td>         
         <td>Trem (1810m.)</td>
         <td>A. Bujagić </td>
      </tr>

      <tr>       
         <td>Jun 05-07</td>         
         <td>Kanjon reke Cvrcke</td>
         <td>B. Marković </td>
      </tr>
      <tr>       
         <td>Jun 14</td>         
         <td>Jastrebac (1492m.)</td>
         <td>D. Jaćimović </td>
      </tr>
      <tr>       
         <td>Jun 20-21</td>         
         <td>Bjeljina</td>
         <td>B. Marković </td>
      </tr>
      <tr>       
         <td>Jun 27-28</td>         
         <td>Tatre</td>
         <td>M. Čolić </td>
      </tr>
      <tr>       
         <td>Jul 05</td>         
         <td>Bukulja</td>
         <td>J. Janošević</td>
      </tr>
      <tr>       
         <td>Jul 12</td>         
         <td>Akcija iznenađenja</td>
         <td> </td>
      </tr>
      <tr>       
         <td>Jul 17-19</td>         
         <td>Јеzera Zelengore</td>
         <td>B. Marković </td>
      </tr>
       <tr>       
         <td>Avgust 02</td>         
         <td>Fruška Gora</td>
         <td>M. Jeremić</td>
      </tr>
      <tr>       
         <td>Avgust 09</td>         
         <td>Stolovi</td>
         <td>M. Jeremić</td>
      </tr>
      <tr>       
         <td>Avgust 14-16</td>         
         <td>Durmitor (2523m.)</td>
         <td>B. Marković </td>
      </tr>
      <tr>       
         <td>Avgust 23</td>         
         <td>Kanjon Crne reke</td>
         <td>M. Jeremić</td>
      </tr>
      <tr>       
         <td>Avgust 28-30</td>         
         <td>Komovi</td>
         <td>A. Bujagić</td>
      </tr>
      <tr>       
         <td>Septembar 04-06</td>         
         <td>Miroč (768m.)</td>
         <td>M. Jeremić</td>
      </tr>
      <tr>       
         <td>Septembar 13</td>         
         <td>Željin (1758m.)</td>
         <td>J. Rakić</td>
      </tr>
      <tr>       
         <td>Septembar 23</td>         
         <td>Olimp (2918m.)</td>
         <td>B. Marković</td>
      </tr>
      <tr>       
         <td>Septembar 27</td>         
         <td>Čišćenje staze na Kosmaju</td>
         <td></td>
      </tr>
      <tr>       
         <td>Oktobar 4</td>         
         <td>S Grebenom Despotovim stazama</td>
         <td></td>
      </tr>
      <tr>       
         <td>Oktobar 9-11</td>         
         <td>Pirin (2914m.)</td>
         <td>A. Bujagić</td>
      </tr>
      <tr>       
         <td>Oktobar 18</td>         
         <td>Jasenica</td>
         <td>J. Janošević</td>
      </tr>
      <tr>       
         <td>Oktobar 25</td>         
         <td>Kotlenik (749m.)</td>
         <td>R. Žmurić</td>
      </tr>
      <tr>       
         <td>Novembar 01</td>         
         <td>Lazarev kanjon (1158m.)</td>
         <td>J. Janošević</td>
      </tr>
      <tr>       
         <td>Novembar 06-08</td>         
         <td>Šatorice </td>
         <td>B. Marković</td>
      </tr>
      <tr>       
         <td>Novembar 14-15</td>         
         <td>Tara (1591m.)</td>
         <td>A. Bujagić</td>
      </tr>
      <tr>       
         <td>Novembar 22</td>         
         <td>Kosmaj</td>
         <td>S. Filipović</td>
      </tr>
      <tr>       
         <td>Novembar 29</td>         
         <td>Jelica</td>
         <td>J. Janošević</td>
      </tr>
      <tr>       
         <td>Decembar 06</td>         
         <td>Garaško jezero</td>
         <td>S. Filipović</td>
      </tr>
      <tr>       
         <td>Decembar 13</td>         
         <td>Divčibare (975m.)</td>
         <td>J. Janošević</td>
      </tr>
      <tr>       
         <td>Decembar 26</td>         
         <td>Avala iz 4 pravca</td>
         <td>M. Matić</td>
      </tr>



        
      
      </tbody>
   </table>
</div>
  
</div>
);


export default GodisnjiPlan;